// офк IE не может в клипбоард, поэтому делаем хитрый маневр
const fallbackCopyToClipboard = (code: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = code

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    const msg = successful ? 'successful' : 'unsuccessful'
    console.log('Fallback: Copying text command was ' + msg)
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)
}

const copyToClipboard = async (code: string) => {
  if (!navigator.clipboard) return fallbackCopyToClipboard(code)
  try {
    await navigator.clipboard.writeText(code)
  } catch (error) {
    console.log(error)
  }
}

export { copyToClipboard }
